<template>
  <highcharts class="fit-highchart" :options="options" style="width: 100%" />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import { routePath } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import { areaOptions } from '@/constants/chart-options';

export default {
  name: 'WSummaryAreaChart',
  props: {
    series: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      options: cloneDeep(areaOptions),
      visible: false,
    };
  },
  watch: {
    series() {
      this.options.chart.height = '140px';
      this.options.series = this.series;
      // 툴팁 단위 표현
      if (!isNil(this.series[0].rscUnit)) {
        this.options.tooltip.valueSuffix = this.series[0].rscUnit;
      }
    },
  },
  /**
   * 차트의 Click Event
   * @author kimjy
   */
  mounted() {
    // this.options.chart.height = '170px';

    const me = this;
    // Series 포인터 클릭
    Object.assign(this.options.plotOptions.area, {
      events: {
        click(e) {
          me.chartClick(this.chart, e);
        },
      },
    });

    // 차트 영역 클릭
    this.options.chart.events = {
      click(e) {
        me.chartClick(this, e);
      },
    };
  },
  methods: {
    chartClick(chart, e) {
      const point = chart.series[0].searchPoint(e, true);
      this.$store.dispatch('setPlotLineDatetime', point.x);
      this.$store.dispatch('setInitialDatetimeRange', { type: 'interval', interval: 'hour', value: 12 });
      routePath(this, menuDefine.PERF_OPER, this.$route.params.treeKey, performanceNodeTabs.analysis.name, null, true);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/SummaryAreaChart.vue